export default __webpack_public_path__ + "static/media/ReportIcon-iDataPharma-MS.5334bd41.jpg";